<template>
  <div class="grid__unit">
   <slot></slot>
    <fieldset class="border p-2">
      <legend class="w-auto">Grid {{ uniqueId }}</legend>
      
      <div class="form-group">
        <label :for="'gridTitle_'+uniqueId">Title</label>
        <input
          :id="'gridTitle_'+uniqueId"
          :key="'gridTitle_key_'+uniqueId"
          class="form-control"
          
          type="text"
          placeholder=""
        />
      </div>

      <div class="form-group">
        <label :for="'gridURL_'+uniqueId">URL</label>
        <input
          :id="'gridURL_'+uniqueId"
          :key="'gridURL_key_'+uniqueId"
          class="form-control"
          v-model="inputURL"
          type="url"
          placeholder=""
        />
      </div>
    </fieldset>
  </div>
</template>
<script>
export default {
  name: "GridContainer",
  props: {
    uniqueId: Number
  },
  computed: {
    inputTitle: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("inputTitle", val);
      }
    },
    inputURL: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("inputURL", val);
      }
    }
  },
  data() {
    return {};
  },
  methods: {
  }
};
</script>
<style scoped>

</style>
